import React, {Component} from 'react'

class Testimonials extends Component {
    render() {
        return (
            <div id="testimonialsIndex">
                <h1><i className="far fa-smile-beam" /> Testimonials </h1>
                <p style={{color: '#5a5a5a'}}>Find out what some of our students had to say about us <span role="img" aria-label="smile-emoji"> 😀</span></p>
                <div id="testimonialsGrid">
                    <div id="tGrid1" className="card">
                        <i>Loved Adhaar as my SAT tutor. My score went up 120 points!</i>
                        <br/>
                        <b>Christina, 12th grade</b>
                    </div>
                    <div id="tGrid2" className="card">
                        <i>I am so glad my daughter can now speak Hindi. Thanks Alok!</i>
                        <br/>
                        <b>Shree, IT Professional</b>
                    </div>
                    <div id="tGrid3" className="card">
                        <i>Honestly nothing in Chem was making sense before Dr. Sharma.</i>
                        <br/>
                        <b>Monique, 11th grade</b>
                    </div>
                    <div id="tGrid4" className="card">
                        <i>I didn't except Dr. Nevadita to answer my phone even late at night!</i>
                        <br/>
                        <b>Suresh, BS in Bio, 2nd year</b>
                    </div>
                    <div id="tGrid5" className="card">
                        <i>I was able to code an awesome web app all thanks to Adhaar! Rock on man!</i>
                        <br/>
                        <b>Brian, BS in CS, 4th year</b>
                    </div>
                    <div id="tGrid6" className="card">
                        <i>I was able to ace my Organic Chem class! Med school here I come!</i>
                        <br/>
                        <b>Tulsi, BS in Bio, 3rd year</b>
                    </div>
                </div>
            </div>
        )
    }
}

export default Testimonials